import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
import { css } from '@patternfly/react-styles';
import { WizardDrawerWrapper } from './WizardDrawerWrapper';
import { Drawer, DrawerContent } from '../Drawer';
export var WizardBody = function WizardBody(_ref) {
  var children = _ref.children,
    _ref$hasNoBodyPadding = _ref.hasNoBodyPadding,
    hasNoBodyPadding = _ref$hasNoBodyPadding === void 0 ? false : _ref$hasNoBodyPadding,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    _ref$mainComponent = _ref.mainComponent,
    mainComponent = _ref$mainComponent === void 0 ? 'div' : _ref$mainComponent,
    hasDrawer = _ref.hasDrawer,
    isDrawerExpanded = _ref.isDrawerExpanded,
    onExpandDrawer = _ref.onExpandDrawer,
    activeStep = _ref.activeStep;
  var MainComponent = mainComponent;
  return React.createElement(MainComponent, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: css(styles.wizardMain)
  }, React.createElement(WizardDrawerWrapper, {
    hasDrawer: hasDrawer && activeStep.drawerPanelContent,
    wrapper: function wrapper(children) {
      return React.createElement(Drawer, {
        isInline: true,
        isExpanded: isDrawerExpanded,
        onExpand: onExpandDrawer
      }, React.createElement(DrawerContent, {
        panelContent: activeStep.drawerPanelContent
      }, children));
    }
  }, React.createElement("div", {
    className: css(styles.wizardMainBody, hasNoBodyPadding && styles.modifiers.noPadding)
  }, children)));
};
WizardBody.displayName = 'WizardBody';